import {
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const sampleAppointments = [
  { id: 1, patient: "John Doe", date: "2025-10-10", time: "10:00 AM" },
  { id: 2, patient: "Jane Smith", date: "2025-10-11", time: "11:00 AM" },
  { id: 3, patient: "Michael Brown", date: "2025-10-12", time: "02:00 PM" },
];

export default function Appointments() {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" color="primary" gutterBottom>
        Appointments
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Patient</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sampleAppointments.map((a) => (
              <TableRow key={a.id}>
                <TableCell>{a.id}</TableCell>
                <TableCell>{a.patient}</TableCell>
                <TableCell>{a.date}</TableCell>
                <TableCell>{a.time}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
